<template>
  <div>
    <v-row>
      <v-col md="4">
        <ModuleHeader>Rondas prepagadas</ModuleHeader>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="6">
        <v-text-field
          v-if="false"
          v-model="filter"
          label="Filtrar"
        ></v-text-field>
      </v-col>
      <v-col md="6" class="text-right">
        <v-btn color="green" dark class="mr-5" @click="exportExcel">
          <v-icon>mdi-file-excel-box</v-icon>
          Exportar a Excel
          <!-- <download-excel
            type="xls"
            name="Reporte Existencias"
            :data="excelData"
          >
          </download-excel> -->
        </v-btn>

        <v-btn @click="generatePdf()" color="red" dark> Generar pdf </v-btn>
      </v-col>
    </v-row>

    <DataTable
      :config="config"
      :data="clientShow"
      :pageRows="15"
      @buttonClick="dtButtonClick"
    ></DataTable>
    <v-dialog v-model="showmodel" width="800" scrollable>
      <div v-if="selectedClient">
        <v-card v-if="selectedClient.Cupones.length > 0">
          <v-card-title class="primary white--text">
            Detalles
            <v-spacer></v-spacer>
            <v-icon @click="showmodel = false" dark>mdi-close</v-icon>
          </v-card-title>

          <v-tabs>
            <v-tab>Cupones</v-tab>
            <v-tab>Usados</v-tab>
            <v-tab-item>
              <v-card-text>
                <h3>
                  Detalles de los cupones de
                  {{ selectedClient.NombreCompleto }}
                </h3>
                <v-simple-table
                  dense
                  style="max-height: 50vh; overflow-y: auto"
                >
                  <thead>
                    <tr>
                      <th>Cupón</th>
                      <th>Expiración</th>
                      <th>Departamento</th>
                      <th>Rondas Disponibles</th>
                      <th>Rondas Reservadas</th>
                      <th>Precio</th>
                      <th>Editar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(cupon, index) in selectedClient.Cupones"
                      :key="index"
                    >
                      <td class="px-0 text-center">{{ cupon.Cupon.Nombre }}</td>
                      <td class="px-0 text-center">
                        <span v-if="!cupon.editing">{{ cupon.Exp.FT }}</span>
                        <span v-else>
                          <Datepicker
                            @selected="
                              (date) => selectDate(date, cupon.editableCopy)
                            "
                            :value="cupon.editableCopy.Exp.FT.format('YYYY/MM/DD')"
                            :input-class="'inputpicker-fix'"
                            :calendar-class="'datepicker-fix'"
                          ></Datepicker
                        ></span>
                      </td>
                      <td class="px-0 text-center">
                        {{ cupon.Cupon.Departamento }}
                      </td>
                      <td class="px-0 text-center">
                        <span v-if="!cupon.editing">{{
                          cupon.Con.Disponibles
                        }}</span>
                        <span v-else>
                          <v-text-field
                            style="width: 5vh; justify-self: center"
                            dense
                            type="number"
                            v-model="cupon.editableCopy.Con.Disponibles"
                          ></v-text-field
                        ></span>
                      </td>
                      <td class="px-0 text-center">
                        <span v-if="!cupon.editing">{{
                          cupon.Con.Reservados
                        }}</span>
                        <span v-else>
                          <v-text-field
                            style="width: 5vh"
                            dense
                            type="number"
                            v-model="cupon.editableCopy.Con.Reservados"
                          ></v-text-field
                        ></span>
                      </td>
                      <td class="px-0 text-center">{{ cupon.Cupon.Precio }}</td>
                      <td class="px-0 text-center">
                        <v-btn
                          icon
                          @click="startEditing(cupon)"
                          v-if="!cupon.editing"
                        >
                          <v-icon>mdi-pencil</v-icon></v-btn
                        >
                        <span v-else>
                          <v-btn icon @click="saveEditing(cupon)">
                            <v-icon>mdi-content-save</v-icon></v-btn
                          >
                          <v-btn icon @click="cancelEditing(cupon)">
                            <v-icon>mdi-close</v-icon></v-btn
                          >
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <h3>
                  Detalles de los cupones de
                  {{ selectedClient.NombreCompleto }}
                </h3>
                <v-simple-table v-if="usados.length > 0">
                  <thead>
                    <tr>
                      <th>Folio</th>
                      <th>Fecha</th>
                      <th>Total</th>
                      <th>Departamento</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(cuponUsado, index) in usados" :key="index">
                      <td>{{ cuponUsado.Folio }}</td>
                      <td>{{ cuponUsado.FechaVenta }}</td>
                      <td>{{ cuponUsado.Total }}</td>
                      <td>{{ cuponUsado.Departamento }}</td>
                      <td>{{ cuponUsado.Catalogo[0].Nombre }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <v-card flat v-else> No se ha usado ningún cupón. </v-card>
              </v-card-text>
              <v-card-text v-if="false">
                <h3>Detalles de cupones usados</h3>
                <v-list
                  v-if="usados.length > 0"
                  style="max-height: 50vh; overflow-y: auto"
                >
                  <v-list-item
                    v-for="(cuponUsado, index) in usados"
                    :key="index"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        Folio: {{ cuponUsado.Folio }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Fecha: {{ cuponUsado.FechaVenta }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        Total: {{ cuponUsado.Total }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        Departamento: {{ cuponUsado.Departamento }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        {{ cuponUsado.Catalogo[0].Nombre }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-list v-else>
                  <v-list-item-title>
                    No se ha usado ningún cupón.
                  </v-list-item-title>
                </v-list>
              </v-card-text>
            </v-tab-item>
          </v-tabs>
        </v-card>
        <v-card v-else>
          <v-card-text>
            {{ alerta() }}
          </v-card-text>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import Cliente from "../../clases/Cliente.js";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import DataTable from "../MainComponents/DataTable.vue";
import ReporteRondasPrepagadas from "../../clases/PdfMakers/ReporteRondasPrepagadas.js";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import GenericExcelExporter from "../../clases/ExcelMaker/GeneralExcel.js";
import Datepicker from "vuejs-datepicker";

export default {
  name: "RondasPrepagadas",
  props: [],
  components: {
    DataTable,
    Datepicker,
  },
  data() {
    return {
      rondas: [],
      filter: "",
      selectedClient: null,
      showmodel: false,
      usados: [],
      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: true,
        allowExport: false,
        rawText: "Rondas Prepagadas",
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [],
        fields: [
          {
            text: "Nombre",
            value: "NombreCompleto",
          },
          {
            text: "Identificador",
            value: "id",
          },
          {
            text: "Rondas disponibles",
            value: "CuponesDisponibles",
          },
          {
            text: "Rondas Reservadas",
            value: "CuponesReservados",
          },
          {
            text: "Detalle",
            value: "Id",
            buttons: [
              {
                color: "green",
                text: "Detalle",
                buttonId: "showDetail",
                value: "Id",
                showBy: "Id",
              },
            ],
          },
        ],
      },
      editing: false,
    };
  },
  methods: {
    selectDate(date, target) {
      target.Exp.FT = moment(date);
    },

    startEditing(cupon) {
      cupon.editing = true;
      cupon.editableCopy = this.$pgsHelper.cloneObj(cupon);
      cupon.editableCopy.Exp.FT = moment(cupon.editableCopy.Exp.FT);
    },

    cancelEditing(cupon) {
      cupon.editing = false;
      cupon.editableCopy = null;
    },

    saveEditing(cupon) {
      const editable = cupon.editableCopy;
      const dataToSend = {
        IdCliente: this.selectedClient.Id,
        Cupones: [
          {
            CCI: editable._CCI,
            Exp: {
              FT: moment(editable.Exp.FT).format("YYYY-MM-DD"),
              FI: moment(editable.Exp.FI).format("YYYY-MM-DD"),
              ES: editable.Exp.ES,
            },
            Con: {
              Disponibles: Number(editable.Con.Disponibles),
              Reservados: Number(editable.Con.Reservados),
              Usados: Number(editable.Con.Usados),
            },
          },
        ],
      };

      console.log(dataToSend, "dataToSend", cupon, "cupon");

      this.$swal({
        title: "Deseas guardar estos cambios?",
        text: "Los cambios en el cupón se guardará con los datos especificados",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Clientes-atualizarCupones", dataToSend)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Cupón Guardada",
              "El cupón se almacenó correctamente",
              "success"
            );
            cupon.editing = false;
            cupon.editableCopy = null;
            this.showmodel = false;
            this.data_clientes();
            // this.$forceUpdate();
          } else {
            this.$swal(
              "Error al guardar los datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    exportExcel() {
      GenericExcelExporter.generateExcelBuffer(this.excelData)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Rondas prepagadas.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjec2207tURL(url);
        })
        .catch((error) => console.error("Error exportando:", error));
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "showDetail") {
        let cliente = this.$pgsHelper.getById(
          this.clientShow,
          "Id",
          idSelected
        );
        this.selectClient(cliente);
      }
    },
    async generatePdf() {
      let mainData = {
        TITLE: "Reporte Rondas Prepagadas",
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: this.clientShow,
      };
      let docData = ReporteRondasPrepagadas.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    selectClient(cliente) {
      this.selectedClient = this.$pgsHelper.cloneObj(cliente);
      this.selectedClient.Cupones = cliente.Cupones.map((cupon) => {
        return {
          ...cupon,
          editing: false,
        };
      });
      this.getUsedSeries();
      this.showmodel = true;
    },
    async getUsedSeries() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("PDV_Ventas", [
        firestore.where("Cliente.Id", "==", this.selectedClient.Id),
        firestore.where("_ProdIdx", "array-contains-any", [
          "~Golf~Ronda~Serie~-Golf",
          "~Golf~Ronda~Serie~",
        ]),
      ]);
      let data_ventas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      this.usados = data_ventas;
    },
  },
  computed: {
    data_clientes() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((cliente) => {
        let Contadores = { Disponibles: 0, Reservados: 0 };
        cliente.NombreCompleto = cliente.Nombres + " " + cliente.Apellidos;
        cliente.CuponesDisponibles = 0;
        cliente.CuponesReservados = 0;
        cliente.id = cliente.Id;
        if (cliente.Cupones.length > 0) {
          let cupones = cliente.Cupones.sort(function (a, b) {
            return new Date(b.Exp.FT) - new Date(a.Exp.FT);
          });
          cupones.forEach((serie) => {
            if (serie.Exp.FT >= moment().format("YYYY-MM-DD")) {
              cliente.CuponesDisponibles = Contadores.Disponibles +=
                serie.Con.Disponibles;
              cliente.CuponesReservados = Contadores.Reservados +=
                serie.Con.Reservados;
            }
          });
        } else {
          cliente.CuponesDisponibles = 0;
          cliente.CuponesReservados = 0;
        }

        clientes.sort((a, b) => b.CuponesDisponibles - a.CuponesDisponibles);

        clientes.push(cliente);
      });

      return clientes;
    },
    clientShow() {
      let cliente = this.data_clientes;
      if (this.filter != "") {
        return cliente.filter((acc) =>
          acc.NombreCompleto.toUpperCase().includes(this.filter.toUpperCase())
        );
      }
      return cliente;
    },
    alerta() {
      let nombre = this.selectedClient.NombreCompleto;
      return this.$swal("Cliente " + nombre + " no cuenta con cupones");
    },
    excelData() {
      let ExcelData = [];
      if (this.filter != "") {
        this.clientShow.forEach((element) => {
          if (element.Cupones) {
            element.Cupones.forEach((cupon) => {
              console.log(cupon);
              let DataProd = {
                Nombre: element.NombreCompleto,
                Cupon: cupon.Cupon.Nombre,
                Rondas_Disponibles: cupon.Con.Disponibles,
                Vigencia: cupon.Exp.FI + " - " + cupon.Exp.FT,
              };
              ExcelData.push(this.$pgsHelper.cloneObj(DataProd));
            });
          }
        });
      } else if (this.filter == "") {
        this.data_clientes.forEach((element) => {
          if (element.Cupones) {
            element.Cupones.forEach((cupon) => {
              console.log(cupon);
              let DataProd = {
                Nombre: element.NombreCompleto,
                Cupon: cupon.Cupon.Nombre,
                Rondas_Disponibles: cupon.Con.Disponibles,
                Vigencia: cupon.Exp.FI + " - " + cupon.Exp.FT,
              };
              ExcelData.push(this.$pgsHelper.cloneObj(DataProd));
            });
          }
        });
      }
      return ExcelData;
    },
  },
};
</script>

<style>
.datepicker-fix {
  z-index: 3000 !important;
  position: fixed !important;
  overflow: auto;
}
.inputpicker-fix {
  justify-items: center;
  border: 1px solid gray !important;
  border-radius: 4px !important;
}
</style>
